import React from 'react';

const ProductPriceAndInventory = ({ currentVariation }) => {
    const showPrice = typeof currentVariation.PriceViewModel !== 'undefined'
        && currentVariation.PriceViewModel !== null
        && (currentVariation.PriceViewModel.IsSalePrice
            ? currentVariation.PriceViewModel.SalePrice !== '$0.00'
            : currentVariation.PriceViewModel.RegularPrice !== '$0.00');
    const price = !showPrice
        ? 0
        : currentVariation.PriceViewModel.IsSalePrice
            ? currentVariation.PriceViewModel.SalePrice
            : currentVariation.PriceViewModel.RegularPrice;

    const priceLabel = showPrice ? <b>{`Your Price: ${price}`}</b> : null;

    const showInventory = typeof currentVariation.InventoryDetails !== 'undefined' && currentVariation.InventoryDetails !== null;
    //let stockClassName = "";
    //let inventoryMessage = "";

    //if (showInventory) {
    //    if (!!currentVariation.InventoryDetails.TotalInStock) {
    //        if (currentVariation.InventoryDetails.TotalInStock < currentVariation.InventoryDetails.MinStockLevel) {
    //            stockClassName = "low-stock-number"
    //            inventoryMessage = "Low inventory"
    //            if (!!currentVariation.InventoryDetails.DeliveryDate) {
    //                inventoryMessage += ", additional being added on " + currentVariation.InventoryDetails.DeliveryDate;
    //            }
    //        }
    //    } else {
    //        if (!!currentVariation.InventoryDetails.DeliveryDate) {
    //            inventoryMessage = "Out of stock"
    //        } else {
    //            inventoryMessage = "In stock on " + currentVariation.InventoryDetails.DeliveryDate;
    //        }
    //    }
    //} else {
    //    inventoryMessage = "Inventory not available.";
    //}

    let inventoryLabelText = "";
    if (showInventory) {
        if (!currentVariation.InventoryDetails.TotalInStock) {
            inventoryLabelText = "Out of stock."
        } else {
            inventoryLabelText = currentVariation.InventoryDetails.TotalInStock + " in stock."
        }
    } else {
        inventoryLabelText = "Inventory not available."
    }

    //{!!inventoryMessage && <h5 className="inventory-message">{inventoryMessage}</h5>}

    return (
        <div className='col-xs-12 js-price'>
            <div className='price-and-inventory-label'>
                <h4>
                    <span className="price-label">{priceLabel}</span>
                    {priceLabel && showInventory ? " | " : " "}
                    {!!showInventory && <span className="inventory-label">{inventoryLabelText}</span>}
                </h4>
            </div>
        </div>
    );
};

export default ProductPriceAndInventory;